export { CaptchaComponent } from './captcha.component';
export { CAPTCHA_CONFIG } from './captcha.config';
export { CaptchaConfig } from './captcha.interface';
export { CaptchaModule } from './captcha.module';
